import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.global.page.color};
`;

export const OrangeLine = styled.div`
	width: 100%;
	height: 4px;
	background-color: ${({ theme }) => theme.global.colors.primary.color};
`;

export const Content = styled.div`
	display: flex;
`;

export const Header = styled.header`
	display: flex;
	position: relative;

	width: 100%;
	align-items: center;
	text-align: center;
	flex-wrap: wrap;
	background-color: ${({ theme }) =>
		theme.global.page.authenticatedHeader.color};
`;

export const Logo = styled.div`
	padding: 24px 0 18px 25px;
	height: 68px;

	img {
		width: 160px;
		margin: initial;
	}

	&.-mobile {
		width: 100%;
		order: 1;
		padding: 11px 0;
		height: 56px;

		img {
			width: 122px;
			height: 28px;
			margin: auto;
		}
	}
`;
